import type {
    EventTypeResponse, NewEventInput, NewEventResponse, EventResponse,
    EventsFilter, EventVisibilityRecord, UpdateEventsVisibilityPayload,
    EventAttachmentInput, EventAttachmentResponse, EventAttachmentsResponse,
    EditEventInput, EditEventResponse
} from "../types"
import { instance } from "./api"
import { useAuthStore } from '../stores/t-auth';

export async function getEventTypes(event_group?: string) {
    const auth = useAuthStore();
    const query = event_group ? `?event_group=${encodeURIComponent(event_group)}` : '';
    return await instance.get<EventTypeResponse>(`/events/types${query}`, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function getEvents(filters: EventsFilter) {
    const auth = useAuthStore();
    let filtros = '?user_id=' + auth.logedUser + '&';
    const params = [
        filters.visible ? `user_visible=${filters.visible}` : '',
        filters.state ? `state=${filters.state}` : '',
        filters.scope ? `scope=${filters.scope}` : '',
        filters.type ? `type=${filters.type}` : '',
        filters.start_date ? `start_date=${filters.start_date}` : '',
        filters.end_date ? `end_date=${filters.end_date}` + '235959' : '',
        filters.lat_zona ? `lat_zona=${filters.lat_zona}` : '',
        filters.lon_zona ? `lon_zona=${filters.lon_zona}` : '',
        filters.rad_zona ? `rad_zona=${filters.rad_zona}` : '',
        filters.predio_name ? `predio_name=${filters.predio_name}` : '',
        filters.predio_rad ? `predio_rad=${filters.predio_rad}` : '',
        filters.inicio_rango ? `inicio_rango=${filters.inicio_rango}` : '',
        filters.fin_rango ? `fin_rango=${filters.fin_rango}` : '',
        filters.mission ? `mission=${filters.mission}` : ''
    ].filter(param => param).join('&');

    filtros += params;
    console.log("QueryString" + filtros);
    return await instance.get<EventResponse>("/events" + filtros, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function postEvent(input: NewEventInput) {
    const auth = useAuthStore();
    return await instance.post<NewEventResponse>("/events/web", { parameters: input }, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token,
            ContentType: 'application/json'
        }
    });
}
async function putEvent(input: EditEventInput) {
    const auth = useAuthStore();
    return await instance.put<EditEventResponse>("/events/web",  input , {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token,
            ContentType: 'application/json'
        }
    });
}
async function updateEventsVisibility(records: EventVisibilityRecord[]) {
    const auth = useAuthStore();
    const payload: UpdateEventsVisibilityPayload = {
        parameters: {
            records
        }
    };
    return await instance.post("/eventsv_batch_req", payload, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token,
            'Content-Type': 'application/json'
        }
    });
}

async function createEventAttachment(input: EventAttachmentInput) {
    const auth = useAuthStore();

    return await instance.post<EventAttachmentResponse>("/events/attachment", input, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token,
            'Content-Type': 'application/json'
        }
    });
}
async function getEventAttachments(eventNumber: number) {
  const auth = useAuthStore();

  return await instance.get<EventAttachmentsResponse>(`/events/attachment/${eventNumber}`, {
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + auth.token,
    },
  });
}
async function getEventsPropios(startDate: string, endDate: string, userId: string) {
    const auth = useAuthStore();
    const query = `?start_date=${startDate}&end_date=${endDate}&user_id=${userId}`;
    return await instance.get<EventResponse>("/events/web" + query, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}
export default {
    getEventTypes,
    getEvents,
    postEvent,
    updateEventsVisibility,
    createEventAttachment,
    getEventAttachments,
    putEvent,
    getEventsPropios
};